import { AuthenticationDetails, CognitoUserPool, CognitoUser } from 'amazon-cognito-identity-js'
import { awsInfo } from './aws-info'

const signin = async (username, password) => new Promise((resolve, reject) => {
  const authenticationData = {
    Username: username,
    Password: password,
  };
  const authenticationDetails = new AuthenticationDetails(authenticationData);
  const poolData = {
    UserPoolId: awsInfo.userPoolId,
    ClientId: awsInfo.appClientId,
  };
  const userPool = new CognitoUserPool(poolData);
  const userData = {
    Username: username,
    Pool: userPool
  };
  const cognitoUser = new CognitoUser(userData);
  cognitoUser.authenticateUser(authenticationDetails, {
    onSuccess: function (result) {
      resolve(result)
    },
    onFailure: function (err) {
      reject(err)
    },
  })
})

const signout = async () => new Promise((resolve, reject) => {
  const poolData = {
    UserPoolId: awsInfo.userPoolId,
    ClientId: awsInfo.appClientId,
  };
  const userPool = new CognitoUserPool(poolData);
  const cognitoUser = userPool.getCurrentUser();
  if (cognitoUser) {
    cognitoUser.signOut((err, session) => {
      if (err) {
        reject(err)
      } else {
        resolve(session)
      }
    })
  }
})

const getCurrentUser = async () => new Promise((resolve, reject) => {
  const poolData = {
    UserPoolId: awsInfo.userPoolId,
    ClientId: awsInfo.appClientId,
  };
  const userPool = new CognitoUserPool(poolData);
  const cognitoUser = userPool.getCurrentUser();
  if (!cognitoUser) {
    reject('need login')
  } else {
    cognitoUser.getSession((err, session) => {
      if (err) {
        reject(err)
      } else if (!session.isValid()) {
        reject('need login')
      } else {
        resolve(session)
      }
    })
  }
})

export { signin, signout, getCurrentUser }
